import { FunctionComponent } from 'react';
import styles from '../../../styles/ArticleFooter.module.scss';
import { AuthorModel } from '../../../services/content/author/models/AuthorModel';
import Link from 'next/link';
import { Routes } from '../../../constants/Routes';
import S365Picture from '../../Image/S365Picture';

type Props = {
    author?: AuthorModel;
    customAuthor?: string;
    className?: string;
};

const customPlaceHolder = '/user-placeholder.png';

export const Author: FunctionComponent<Props> = ({ author, customAuthor, className }) => {
    if (customAuthor) {
        return (
            <div className={className}>
                <S365Picture
                    className={`${styles.authorAvatar} normalize-nextjs-image me-2`}
                    url={null}
                    alt={author ? `Автор: ${author.name}` : ''}
                    customPlaceHolder={customPlaceHolder}
                />
                <span>{customAuthor}</span>
            </div>
        );
    }

    return (
        <div className={className}>
            <Link href={Routes.openAuthor(author?.id)}>
                <S365Picture
                    className={`${styles.authorAvatar} normalize-nextjs-image me-2`}
                    url={author?.avatarUrl ?? null}
                    alt={author ? `Автор: ${author.name}` : ''}
                    customPlaceHolder={customPlaceHolder}
                />
                <span>{author?.name}</span>
            </Link>
        </div>
    );
};
